import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getNewDialogs: analyticsTypes.GetNewDialogs = () => {
  return axios.get(`/analytics/new-dialogs`);
};

type QueryFnType = typeof getNewDialogs;

type UseGetNewDialogs = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetNewDialogs = ({ config = {} }: UseGetNewDialogs = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['new-dialogs'],
    queryFn: getNewDialogs,
    cacheTime: 0,
  });
};
